import { Currency } from '@/api-interfaces';

export const API_URL = import.meta.env.VITE_API_BASE_URL;
export const DEFAULT_CURRENCY: Currency = 'USD';

export const TERMS_AND_CONDITIONS_URL: string =
  'https://www.goloot.io/eng/po-terms';

export const DEFAULT_DATE_FIELD_OPTIONS: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  hour: 'numeric',
};
